import { clientHttp } from '@/common/http';
import {
  GetStoreItemsApi,
  getStoreItemsInputSchema,
  getStoreItemsResponseSchema,
} from './get-store-items';

export const getStoreItems: GetStoreItemsApi = async ({
  input,
  headers,
  signal,
}) => {
  try {
    const params = getStoreItemsInputSchema.parse(input);
    const searchParams = new URLSearchParams();

    if (params.ids) {
      searchParams.set('ids', params.ids.join(','));
    }

    if (params.isLoggedIn) {
      searchParams.set('isLoggedIn', 'true');
    }

    if (params.showCouponBadge) {
      searchParams.set('showCouponBadge', 'true');
    }

    const json = await clientHttp
      .get(`/api/promotions/store-items?${searchParams.toString()}`, {
        headers,
        signal,
      })
      .json();
    return getStoreItemsResponseSchema.parse(
      Array.isArray(json) ? { items: json } : json,
    );
  } catch {
    return {
      items: [],
    };
  }
};
